import { Component } from '@angular/core';

@Component({
    selector: 'li-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.sass'],
})
export class AppComponent {
    title = 'liquid-insight-dashboard-webapp';

    something = 'this should fail!';
}
